import {Tag, TagColor, TagSize} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React, {useState} from 'react';

import TextInput from 'ui-library/inputs/TextInput';
import Modal from 'ui-library/modals/Modal';

interface AIAssistedSearchModalResult {
  userPrompt: string;
}

export interface AIAssistedSearchModalProps {
  onRequestSubmit: (result: AIAssistedSearchModalResult) => void;
  onRequestClose: () => void;
}

/**
 * Modal prompting the user's natural language input for Guided Search feature.
 */
export default function AIAssistedSearchModal(props: AIAssistedSearchModalProps): JSX.Element {
  const [userPrompt, setUserPrompt] = useState<string>('');

  return (
    <Modal
      title={
        <div className={css(styles.modalTitle)}>
          <h4>Guided Search</h4>
          <Tag size={TagSize.SMALL} color={TagColor.PURPLE} text="PREVIEW" />
        </div>
      }
      onRequestClose={props.onRequestClose}
      onRequestSubmit={() => {
        props.onRequestSubmit({userPrompt});
      }}
      buttons={[{text: 'Update search settings', submit: true, disabled: !userPrompt}]}
      footer={
        <div className={css(styles.footerDisclaimer)}>
          <span className="glyphicon glyphicon-info-sign u-no-text-decoration" />
          <div>
            <p className={css(styles.disclaimerLine)}>This feature uses AI and may make mistakes.</p>
            <p className={css(styles.disclaimerLine)}>Always verify the results.</p>
          </div>
        </div>
      }
    >
      <section className={css(styles.explanation)}>
        <p>
          Describe what you're looking for, and Guided Search will try to configure your search filters to
          best match. Currently, it works best for registry and notebook-related searches, but we are working
          to expand coverage.
        </p>
        Try asking for…
        <ul>
          <li>HeLa cell lines</li>
          <li>Notebook entries I need to review</li>
          <li>Containers with at least 10uL of SAMPLE001</li>
        </ul>
      </section>
      <div className={css(styles.textInput)}>
        <TextInput
          value={userPrompt}
          onChange={(e) => {
            setUserPrompt(e.target.value);
          }}
          autoFocus={true}
          placeholder="For the best results, be detailed and specific"
        />
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  explanation: {
    fontSize: 13,
  },
  textInput: {
    marginTop: 6,
  },
  footerDisclaimer: {
    alignItems: 'center',
    display: 'flex',
    gap: 8,
    textAlign: 'left',
  },
  disclaimerLine: {
    marginBottom: 0,
  },
  modalTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
});
